import { Vehicle, VehicleInventoryItem } from "@/types";
import { deleteData, getData, postData, putData } from "./axios-service";

function vehicleMapper(input: any): Vehicle {
    return {
        id: input.id,
        label: input.label,
        plateNumber: input.plateNumber,
    };
}

function vehicleInventoryItemMapper(input: any): VehicleInventoryItem {
    const name = input.sparepartName || "";
    const frenchName = input.sparepartFrenchName || "";
    return {
        quantity: input.quantity,
        sparepartId: input.sparepartId,
        sparepartName: name,
        sparepartFrenchName: frenchName,
        displayName: `${name} (${frenchName})`.trim()
    };
}

export function vehicleMapperArray(inputArray: any[]): Vehicle[] {
    return inputArray.map(vehicleMapper);
}

export function vehicleInventoryItemMapperArray(inputArray: any[]): VehicleInventoryItem[] {
    return inputArray.map(vehicleInventoryItemMapper);
}

export async function getAllVehicles(): Promise<Vehicle[]> {
    const vehicles = await getData<Vehicle[]>("vehicles");
    return vehicleMapperArray(vehicles ?? []);
}

export async function getVehicleById(id: string): Promise<Vehicle> {
    const response = await getData("/vehicles/" + id);
    return vehicleMapper(response);
}

export async function getVehicleByTaskListId(taskListId: string): Promise<Vehicle> {
    const response = await getData("/tasklist-vehicles/" + taskListId + "/vehicle");
    return vehicleMapper(response);
}

export async function postVehicle(vehicle: Vehicle): Promise<Vehicle> {
    const response = await postData("/vehicles", vehicle);
    return vehicleMapper(response);
}

export async function putVehicle(vehicle: Vehicle): Promise<Vehicle> {
    const response = await putData("/vehicles/" + vehicle.id, vehicle);
    return vehicleMapper(response);
}

export function deleteVehicle(id: string): Promise<any> {
    return deleteData("/vehicles/" + id);
}

export async function getVehicleInventoryItems(id: string): Promise<VehicleInventoryItem[]> {
    const inventoryItems = await getData<VehicleInventoryItem[]>("/vehicles/" + id + "/inventory");
    return vehicleInventoryItemMapperArray(inventoryItems ?? []);
}

export async function postConsumeInventoryItem(vehicleId: string, inventoryItem: VehicleInventoryItem): Promise<any> {
    return postData("/vehicles/" + vehicleId + "/inventory/consume", inventoryItem);
}

export async function postInventoryItem(vehicleId: string, inventoryItem: VehicleInventoryItem): Promise<any> {
    return postData("/vehicles/" + vehicleId + "/inventory", inventoryItem);
}

export async function deleteInventoryItem(vehicleId: string, sparepartId: string): Promise<any> {
    return deleteData("/vehicles/" + vehicleId + "/inventory/" + sparepartId);
}